import { getBlogCategories } from '../../../src/api/contentful/blog/getBlogCategories';
import { AppLogic } from '../../../src/components/AppLogic/AppLogic';
import { GlobalLayout } from '../../../src/components/Layouts/GlobalLayout';
import { BLOG_PAGE_NAV_LINKS } from '../../../src/constants/constants';
import { NOT_FOUND_WITH_REVALIDATION, REVALIDATE } from '../../../src/constants/next';
import { reportMykissError } from '../../../src/helpers/errorHandling';
import { StaticResult } from '../../../src/interfaces/nextjs';
import {
  BlogAllCategoryPage,
  IBlogAllCategoryPage,
} from '../../../src/views/Blog/CategoryCategories/BlogAllCategoryPage';

export async function getStaticProps(): StaticResult<IBlogAllCategoryPage> {
  try {
    const blogCategories = await getBlogCategories();
    return {
      props: {
        _page: 'blog_category_hub',
        _pageTitle: 'Blog Category Hub',
        blogCategories: blogCategories.items,
      },
      revalidate: REVALIDATE.HOURLY,
    };
  } catch (error) {
    reportMykissError(error);
    return NOT_FOUND_WITH_REVALIDATION;
  }
}

BlogAllCategoryPage.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout siteSubNavigationLinks={BLOG_PAGE_NAV_LINKS}>{page}</GlobalLayout>
    </AppLogic>
  );
};

export default BlogAllCategoryPage;
